<div #flexContainerAroundWrapper class="flex flex-col gap-2 h-full p-2">
  @if (legendPosition === 'top' && tab.legend.length > 0 && tab.outputData.length > 0) {
    <ng-container [ngTemplateOutlet]="legend"></ng-container>
  }
  @for (_ of [recreatePlotEvent$ | async]; track _) {
    <div 
      #plotWrapper
      class="wrapper flex-grow relative"
      [style.--sbi-thingie-detail-distance-buffer]="'226px'"
      data-cy="chart_view_tab__plot_wrapper"
      [attr.data-plot-ready]="plotRenderReady ? 'true' : 'false'"
      [attr.data-plot-data-state]="plotDataState"
    >
      @if (!noDataPresent) {
        <plotly-plot
          #thePlot
          [divId]="'tab-plot-'+tab.graphConfig.uuid"
          [data]="tab.outputData"
          [updateOnDataChange]="false"
          [updateOnLayoutChange]="false"
          [revision]="thePlot.plotlyInstance === undefined ? -1 : (plotRevision$ | async) ?? -1"
          [layout]="tab.layout"
          [useResizeHandler]="false"
          appSafeResizeHandler
          [style]="{position: 'relative', width: '100%', height: '100%'}"
          [config]="tab.plotlyConfig"
          (initialized)="onPlotInitialized()"
          (afterPlot)="onAfterPlot()"
          (relayout)="onRelayout($event)"
          appResetZoomButtons
          [appResetZoomButtonsReset]="removeResetButtons$"
          [appResetZoomButtonsZoomedAxes]="setOfZoomedRanges"
          (mousemove)="onMouseMove($event, tab.outputData)"
          (hover)="hoverEvent$.next({ type: 'hover', event: $event })"
          (unhover)="hoverEvent$.next({ type: 'unhover', event: $event })"
          appPlotlyHoverTimeTooltip
          [appPlotlyHoverTimeTooltipEvents]="hoverEvent$"
          [appPlotlyHoverTimeTooltipPlotly]="thePlot" />
      }
      @if (noDataPresent) {
        <plotly-plot
          #thePlot
          [style]="{position: 'relative', width: '100%', height: '100%'}"
          [layout]="emptyDataLayout"
          [data]="tab.outputData"
          [config]="tab.plotlyConfig"
            (afterPlot)="onAfterPlot()"
          [revision]="thePlot.plotlyInstance === undefined ? -1 : (plotRevision$ | async) ?? -1" />
      }
      @if (noDataPresent && errorMessage === undefined) {
        <div class="no-data-message" data-cy="chart_view_tab__data_message_overlay">
          <ion-icon name="file-tray-outline" />
          @if (tab.graphConfig.internalSeriesList.length === 0) {
            <span>No series selected</span>
          } @else {
            @if (tab.outputData.length > 0) {
              <span>No data present</span>
            } @else {
              <span>Loading...</span>
            }
          }
        </div>
      }
      @if (errorMessage !== undefined) {
        <div class="no-data-message">
          <ion-icon name="file-tray-outline" />
          <span>Error: {{errorMessage}}</span>
        </div>
      }
    </div>
  }

  @if (legendPosition === 'bottom' && tab.legend.length > 0 && tab.outputData.length > 0) {
    <ng-container [ngTemplateOutlet]="legend" />
  }
</div>


<ng-template #legend>

  <!-- Collapse with header -->
  <div class="flex gap-1" data-cy="chart_view_tab__legend_container">
    <div class="flex-1">
      <div 
        class="flex-1 flex flex-nowrap items-center gap-1 overflow-hidden cursor-pointer text-gray-60 text-[0.75rem]"
        role="button"
        (click)="toggleLegend()"
        [matTooltip]="'Toggle legend'"
        data-cy="chart_view_tab__toggle_legend_collapse"
      >
        @if(legendVisible()) {
          <ion-icon name="caret-down-outline" class="text-[1rem]" />
        } @else {
          <ion-icon name="caret-forward-outline" class="text-[1rem]"/>
        }
        <span>Legend</span>
      </div>

      <div 
        #legendwrapper
        class="legendwrapper flex flex-col gap-1"
        [class.hidden]="!legendVisible()"
        data-cy="chart_view_tab__legend_wrapper"
      >
        @for (seriesGroup of ({legend: tab.legend, series: tab.outputData}) | pureFnCall:groupSeriesForLegend; track seriesGroup.name; let i = $index) {
          <div 
            class="flex-initial flex flex-row gap-2 items-baseline"
            [attr.data-cy]="'chart_view_tab__legend__series_group__' + seriesGroup.name"
          >
            <div
              (mouseenter)="_onLegendGroupHover(seriesGroup)"
              (mouseleave)="_onLegendGroupHoverEnd(seriesGroup)"
              (dblclick)="_focusSeriesGroup(seriesGroup)"
              class="flex-initial legend-group-name cursor-pointer"
            >
              <small><b>{{seriesGroup.name}}:</b></small>
            </div>
            <div class="flex-grow flex flex-row flex-wrap legend-entry-list">
              @for (info of seriesGroup.seriesList; track info) {
                <span class="cursor-pointer legend-entry"
                  (click)="_toggleSeriesVisibility(info)"
                  (dblclick)="_focusSeries(info)"
                  [class.disabled]="info.series.visible === false"
                  [attr.data-cy]="'chart_view_tab__legend__series_group__' + seriesGroup.name + '__series__' + info.seriesName"
                >
                  <span
                    class="flex flex-row align-middle"
                    (mouseenter)="_onLegendSeriesHover([info])"
                    (mouseleave)="_onLegendSeriesHoverEnd([info])">
                    <span class="legend-dot" [style.color]="info.series.series.valueConfig.color">{{ info.series.visible === false ? '&#9675;' : '&#9679;' }}</span>
                    <span class="legend-text pl-1 pr-4">
                      <small>
                        @let _modificationInfo = info.seriesModificationInfo ? ' ('+info.seriesModificationInfo+')' : '';
                        @let _modificationInfoLength = info.seriesModificationInfo ? (info.seriesModificationInfo.length + 3) : 0;
                        @if(info.series.series.alias !== undefined && info.series.series.alias.length > 0) {
                          <app-string-ellipsis
                            [input]="info.series.series.alias + (_modificationInfo)"
                            [suffixLength]="5 + (_modificationInfoLength)">
                          </app-string-ellipsis>
                        } @else {
                          <app-string-ellipsis
                            [input]="info.seriesName + (_modificationInfo)"
                            [suffixLength]="5 + (_modificationInfoLength)">
                          </app-string-ellipsis>
                        }
                      </small>
                    </span>
                  </span>
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>

    
    @let warning = tab?._extraData?.calibrationWarning;
    @if (warning) {
      <button
        mat-icon-button
        class="!cursor-help self-end"
        [matTooltip]="warning ?? ''"
        ><ion-icon name="information-circle-outline" class="text-alertYellow-60"></ion-icon>
      </button>
    }
  </div>
</ng-template>
